import React, { useState, useEffect } from 'react';
import './Navbar.scss';
import logo from './../../assets/logo.png';
import { Link } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';

const SERVICES = [
  { label: 'Crown And Bridges', to: '/services/dental-crowns-and-bridges-in-hsr' },
  { label: 'Dental Implants', to: '/services/dental-implants-in-hsr' },
  { label: 'Braces', to: '/services/braces-in-hsr' },
  { label: 'Aligners', to: '/services/aligners-in-hsr' },
  { label: 'Teeth Whitening', to: '/services/teeth-whitening-in-hsr' },
  { label: 'Root Canal Treatment', to: '/services/root-canal-treatment-in-hsr-layout' },
  { label: 'Dental Extraction', to: '/services/dental-extraction-in-hsr-layout' },
  { label: "Children's Dentistry", to: '/services/children-dentistry-in-hsr-layout' },
  { label: 'Trauma Care', to: '/services/TraumaCare-in-hsr-layout' },
  { label: 'Tooth Restoration', to: '/services/tooth-restoration-in-hsr-layout' },
  { label: 'Dental Crown', to: '/services/dental-crown-in-hsr-layout' },
  { label: 'Preventive Dentistry', to: '/services/preventive-dentistry-in-hsr-layout' },
  { label: 'Clear Aligners', to: '/services/clear-aligners-in-hsr-layout' },
  { label: 'Re-Root Canal', to: '/services/re-root-canal-in-hsr-layout' },
  { label: 'Full Mouth Rehabilitation', to: '/services/fmr-in-hsr-layout' },
  { label: 'Dentures', to: '/services/dentures-in-hsr-layout' },
];

const Navbar = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    if (isNavbarOpen) {
      document.body.classList.add('no-scroll-mobile');
      document.documentElement.classList.add('no-scroll-mobile');
    } else {
      document.body.classList.remove('no-scroll-mobile');
      document.documentElement.classList.remove('no-scroll-mobile');
    }

    return () => {
      document.body.classList.remove('no-scroll-mobile');
      document.documentElement.classList.remove('no-scroll-mobile');
    };
  }, [isNavbarOpen]);

  const closeAll = () => {
    setIsNavbarOpen(false);
    setServicesOpen(false);
  };

  return (
    <header className="main-nav w-100">
      <nav className="navbar navbar-expand-lg w-100">
        <div className="container">
          
          {/* Logo */}
          <Link className="navbar-brand ms-lg-3" to="/" onClick={closeAll}>
            <img src={logo} alt="Kosmix Dental Clinic logo" />
          </Link>

          {/* Mobile hamburger */}
          <button
            className="navbar-toggler"
            type="button"
            aria-expanded={isNavbarOpen}
            aria-label="Toggle navigation"
            onClick={() => setIsNavbarOpen(prev => !prev)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Nav links */}
          <div className={`collapse navbar-collapse justify-content-end ${isNavbarOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

              <li className="nav-item">
                <Link className="nav-link" to="/#clinic" onClick={closeAll}>ABOUT</Link>
              </li>

              {/* ── SERVICES DROPDOWN ─────────────────── */}
              <li
                className={`nav-item services-dropdown ${servicesOpen ? 'open' : ''}`}
                onMouseEnter={() => window.innerWidth >= 992 && setServicesOpen(true)}
                onMouseLeave={() => window.innerWidth >= 992 && setServicesOpen(false)}
              >
                <span
                  className="nav-link services-toggle"
                  onClick={() => setServicesOpen(prev => !prev)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => e.key === 'Enter' && setServicesOpen(prev => !prev)}
                >
                  SERVICES <FaChevronDown className={`chevron ${servicesOpen ? 'up' : ''}`} />
                </span>

                <div className="services-panel">
                  <ul className="services-list">
                    {SERVICES.map(({ label, to }) => (
                      <li key={to}>
                        <Link className="service-link" to={to} onClick={closeAll}>
                          {label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
              {/* ─────────────────────────────────────── */}

              <li className="nav-item">
                <Link className="nav-link" to="/#dentist" onClick={closeAll}>DENTIST</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/#associates" onClick={closeAll}>TEAM</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/#gallery" onClick={closeAll}>GALLERY</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/#testimonials" onClick={closeAll}>TESTIMONIALS</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/blogs">BLOGS</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/#contact" onClick={closeAll}>CONTACT</Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
